import { render } from "./Yurtzeiten_Template_Render.vue?vue&type=template&id=ff2310c6&scoped=true"
import script from "./Yurtzeiten_Template_Render.vue?vue&type=script&lang=js"
export * from "./Yurtzeiten_Template_Render.vue?vue&type=script&lang=js"

import "./Yurtzeiten_Template_Render.vue?vue&type=style&index=0&id=ff2310c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff2310c6"]])

export default __exports__